import urljoin from 'url-join';

export function loadService(logicalName: string, tenantName: string, serviceKey: string) {
    const url = urljoin(window.location.origin, logicalName, tenantName, serviceKey + '_');
    window.location.assign(url);
}
